import api from "./ApiClient";

let listeners = [];
let state = { visible: false, status: "progress", };

export const subscribeTx = (fn) => {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter(l => l !== fn);
  };
};

const notify = () => {
  listeners.forEach(fn => fn(state));
};

export const txStart = () => {
  state = { visible: true, status: "progress" };
  notify();
};

export const txDone = () => {
  state = { visible: true, status: "done" };
  notify();
};

export const txAfterDone = () => {
  state = { visible: false, status: "progress" };
  notify();
};

export const getTxState = () => state;

const apiUrl = "https://stats.goptgc.com/api/";

export async function initCSRF() {
  await api.get("/sanctum/csrf-cookie");
  const res = await api.get("/csrf-token");
  const token = res.data?.csrf_token;

  if (token) {
      api.defaults.headers.common["X-CSRF-TOKEN"] = token;

  }
  return token;
}

export async function requestNonce(walletAddress) {
  const res = await api.post("/api/auth/nonce", {
    address: walletAddress
  });
  return res.data;
}

export async function verifySignature(walletAddress, signature) {
  const res = await api.post("/api/auth/verify", {
    address: walletAddress,
    signature
  });
  const token = res.data?.data?.token;
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  return res.data;
}

export const sendPostRequest = async (payload, path) => {
  if(path !=="api/get-proposal" ){
    await initCSRF();
  }
  const res = await api.post(path, payload);
  return res.data;
};

export const sendGetRequest = async (path) => {
  const resp = await fetch(apiUrl + path, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  });
  return resp.json();
};

export const formatVolume = (num) => {
  if (num === null || num === undefined || isNaN(num)) return "Vol. 0";
  if (num >= 1_000_000_000) return `Vol. ${(num / 1_000_000_000).toFixed(2)}B`;
  if (num >= 1_000_000) return `Vol. ${(num / 1_000_000).toFixed(2)}M`;
  if (num >= 1_000) return `Vol. ${(num / 1_000).toFixed(2)}K`;
  return `Vol. ${num}`;
};

export const formatLiquidity = (num) => {
  if (num === null || num === undefined || isNaN(num)) return "Liq. 0";
  if (num >= 1_000_000_000) return `Liq. ${(num / 1_000_000_000).toFixed(2)}B`;
  if (num >= 1_000_000) return `Liq. ${(num / 1_000_000).toFixed(2)}M`;
  if (num >= 1_000) return `Liq. ${(num / 1_000).toFixed(2)}K`;
  return `Liq. ${num}`;
};


export const providerURL = () => {
  const SCAN_LINK = {
    testnet: "https://rpc.pulsechain.com",
    mainnet: "https://rpc.pulsechain.com",
  };
  return SCAN_LINK.mainnet;
};

export const truncateAddress = (address) => {
  if (!address) return "No Account";
  const match = address.match(
    /^(0x[a-zA-Z0-9]{4})[a-zA-Z0-9]+([a-zA-Z0-9]{6})$/
  );
  if (!match) return address;
  return `${match[1]}…${match[2]}`;
};

export const formatDateAndtime = (date) => {
  const d = new Date(date);
  let hours = d.getHours();
  let minutes = d.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  minutes = minutes < 10 ? "0" + minutes : minutes;

  return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()} ${hours}:${minutes} ${ampm}`;
};
